export const URL_PARAMS = {
  SEARCHED_POKEMON: "searched_pokemon",
  PER_PAGE_KEY: "per_page",
  PAGE_KEY: "page",
};

export const POKEMON_TYPES = {
  NORMAL: "normal",
  FIGHTING: "fighting",
  FLYING: "flying",
  POISON: "poison",
  GROUND: "ground",
  ROCK: "rock",
  BUG: "bug",
  GHOST: "ghost",
  STEEL: "steel",
  FIRE: "fire",
  WATER: "water",
  GRASS: "grass",
  ELECTRIC: "electric",
  PSYCHIC: "psychic",
  ICE: "ice",
  DRAGON: "dragon",
  DARK: "dark",
  FAIRY: "fairy",
  UNKNOWN: "unknown",
  SHADOW: "shadow",
};

export const POKEMON_STATS = {
  HP: "hp",
  ATTACK: "attack",
  DEFENSE: "defense",
  SPECIAL_ATTACK: "special-attack",
  SPECIAL_DEFENSE: "special-defense",
  SPEED: "speed",
};

export const POKEMON_TYPES_LIST = [
  {
    id: 10,
    name: { en_us: "fire", pt_br: "Fogo" },
    color: "#CF2C03",
    image: {
      url:
        "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/4.png",
    },
  },
  {
    id: 11,
    name: { en_us: "water", pt_br: "Água" },
    color: "#3B9BF1",
    image: {
      url:
        "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/7.png",
    },
  },
  {
    id: 12,
    name: { en_us: "grass", pt_br: "Planta" },
    color: "#67AF32",
    image: {
      url:
        "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/1.png",
    },
  },
  {
    id: 1,
    name: { en_us: "normal", pt_br: "Normal" },
    color: "#C4C0B4",
    image: {
      url:
        "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/16.png",
    },
  },
  {
    id: 2,
    name: { en_us: "fighting", pt_br: "Lutador" },
    color: "#852816",
    image: {
      url:
        "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/56.png",
    },
  },
  {
    id: 3,
    name: { en_us: "flying", pt_br: "Voador" },
    color: "#8FA4FF",
    image: {
      url:
        "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/12.png",
    },
  },
  {
    id: 4,
    name: { en_us: "poison", pt_br: "Venenoso" },
    color: "#924990",
    image: {
      url:
        "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/23.png",
    },
  },
  {
    id: 5,
    name: { en_us: "ground", pt_br: "Terra" },
    color: "#C5A455",
    image: {
      url:
        "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/27.png",
    },
  },
  {
    id: 6,
    name: { en_us: "rock", pt_br: "Pedra" },
    color: "#5E491C",
    image: {
      url:
        "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/74.png",
    },
  },
  {
    id: 7,
    name: { en_us: "bug", pt_br: "Inseto" },
    color: "#87950C",
    image: {
      url:
        "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/10.png",
    },
  },
  {
    id: 8,
    name: { en_us: "ghost", pt_br: "Fantasma" },
    color: "#6969AF",
    image: {
      url:
        "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/92.png",
    },
  },
  {
    id: 9,
    name: { en_us: "steel", pt_br: "Metálico" },
    color: "#7F8488",
    image: {
      url:
        "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/81.png",
    },
  },

  {
    id: 13,
    name: { en_us: "electric", pt_br: "Elétrico" },
    color: "#E08D00",
    image: {
      url:
        "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/25.png",
    },
  },
  {
    id: 14,
    name: { en_us: "psychic", pt_br: "Psíquico" },
    color: "#E25484",
    image: {
      url:
        "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/63.png",
    },
  },
  {
    id: 15,
    name: { en_us: "ice", pt_br: "Gelo" },
    color: "#8de4f5",
    image: {
      url:
        "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/87.png",
    },
  },
  {
    id: 16,
    name: { en_us: "dragon", pt_br: "Dragão" },
    color: "#7361D1",
    image: {
      url:
        "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/147.png",
    },
  },
  {
    id: 17,
    name: { en_us: "dark", pt_br: "Noturno" },
    color: "#413831",
    image: {
      url:
        "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/197.png",
    },
  },
  {
    id: 18,
    name: { en_us: "fairy", pt_br: "Fada" },
    color: "#E29FE6",
    image: {
      url:
        "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/35.png",
    },
  },
  // { id: 10001, name: { pt_br: "Desconhecido" }, color: "#000" },
  // { id: 10002, name: { pt_br: "Sombrio" }, color: "#2E3053" },
];
